import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { getOrderDetailsMock, getOrdersHistoryListMock } from '.';
import { OrdersHistoryApiService } from '../api';
import { GetOrdersRes } from '../models';
import { GetOrderRes } from '../models/get-order-res.model';

@Injectable()
export class OrdersHistoryMockApiService extends OrdersHistoryApiService {
  override getOrders(): Observable<GetOrdersRes> {
    const items = getOrdersHistoryListMock(50);

    return of<GetOrdersRes>({
      items,
      count: items.length,
      cursor: items.length ? items[items.length - 1].id : null,
    }).pipe(delay(1000));
  }

  override getOrder(): Observable<GetOrderRes> {
    return of<GetOrderRes>(getOrderDetailsMock()).pipe(delay(1000));
  }

  override cancelOrder(): Observable<void> {
    return of(null).pipe(delay(1000));
  }

  override sendComment(): Observable<void> {
    return of(null).pipe(delay(1000));
  }
}
